module.exports = __webpack_public_path__ + "img/SMT_20_Mr_Ho_Yik_Hwee.f6aff069.jpg";